import _ from 'underscore';
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import PaginatedMenuView from '@/views/paginated_menu_view';
import template from '@/../templates/breadcrumb-item.hbs';
import childViewTemplate from '@/../templates/account-change.hbs';

var globalCh = Radio.channel('global');
var ProxyAccountMenuItem = Marionette.View.extend({
    template : Handlebars.compile(childViewTemplate),
    tagName : "li",
    className : function(){
        let primary_account = globalCh.request('primary_account');
        let all_roles = this.model.roles_for(primary_account);
        if (all_roles.length === 1 && all_roles[0].get('name') === 'Blinkup Device') {
            return "hidden";
        }
        return "account";
    },
    ui: {
        link: 'a'
    },
    events: {
        "mouseleave": function(){
            // Solves firefox issue with stuck tooltips
            this.ui.link.tooltip('hide');
        }
    },
    onRender: function() {
        this.ui.link.tooltip({
            delay: {
                show: 1000
            },
            container: 'body'
        });
        this.ui.link.tooltip('hide');
    },
    onDestroy: function() {
        let tooltips = document.getElementsByClassName('tooltip');
        while ( tooltips.length > 0 ) {
          tooltips[0].remove();
        }
    }
});

var AccountChangeView = PaginatedMenuView.extend({
    className: 'ei-breadcrumb-content',
    template: Handlebars.compile(template),
    childView: ProxyAccountMenuItem,
    childViewOptions: _.extend({}, PaginatedMenuView.prototype.childViewOptions, {
        template: Handlebars.compile(childViewTemplate),
        templateContext: function() {
            const primary_account = globalCh.request('primary_account');
            let all_roles = this.model.roles_for(primary_account);
            let mfa_required = false;

            all_roles = all_roles.map(function(model){
                return model.get('name');
            }).sort();

            let roles = all_roles;

            if (roles.length > 1){
                roles = roles[0] + ", +" + (roles.length-1) + " more";
            } else {
                roles = roles.toString();
            }

            roles = roles.toLowerCase();
            if (this.model.get('collaborator_mfa_required') === true && primary_account.get('mfa_enabled') === false){
                mfa_required = true;
                all_roles = `Account ${this.model.get('username')} requires Multi Factory Authentication (MFA) to be enabled.
                            Please enable in your Profile to work on this account.`;
            } else {
                all_roles = 'Your roles: ' + all_roles.toString().replace(/,/g, ", ");
            }

            return {
                my_account: primary_account.id === this.model.id,
                roles: roles,
                all_roles: all_roles,
                mfa_required: mfa_required
            };
        }
    }),
    initialize: function(){
        PaginatedMenuView.prototype.initialize.apply(this, arguments);
        this.on('render:children', function() {
            // after rendering the collection, add a menu item for the active model
            var primary_account = globalCh.request('primary_account');
            var ChildView = this.childView;
            this._addChild(primary_account, ChildView, this.collection.length);
        }, this);
        this.on('select', this.changeAccount);
        var primary_account = globalCh.request('primary_account');
        this.listenTo(primary_account.proxies, 'add_proxy', this.add_proxy);
    },
    add_proxy: function(proxy){
        globalCh.request('update_main_nav');
    },
    events: {
        'click @ui.title': 'click_title'
    },
    changeAccount: function(account, e) {
        var primary_account = globalCh.request('primary_account');
        if ( !account || (account.get('collaborator_mfa_required') === true && primary_account.get('mfa_enabled') === false )){
            return;
        }
        globalCh.request('changeActiveAccount', account, function() {
            globalCh.request('home');
        });
        if ( e && e.which === 1 ) return false;
    },
    viewComparator: function(a, b) {
        var primary_account = globalCh.request('primary_account');
        if (a.id == primary_account.id) {
            return 1;
        } else if (b.id == primary_account.id) {
            return -1;
        } else if (a.get('username') && b.get('username')) {
            return (a.get('username').toLowerCase() < b.get('username').toLowerCase()) ? -1 : 1;
        }
    },
    onRender: function() {
        var active_account = globalCh.request('active_account');
        var primary_account = globalCh.request('primary_account');
        var ChildView = this.childView;
        this.set_active_account(active_account);
        this.set_menu_info('Account');
        if ( this.collection.length === 0 ){
            this._addChild(primary_account, ChildView, this.collection.length);
            this.set_active_account(primary_account);
        }
    },
    set_active_account: function() {
        let active_account = globalCh.request('active_account');
        // Invoke Paginated_Menu_View's method for setting title
        this.set_menu_title(active_account.get('username'));
        this.children.each(function(account){
            if (account.model.get('id') === active_account.get('id')){
                account.$('a').addClass('active');
            } else {
                account.$('a').removeClass('active');
            }
        });
    },
    click_title: function(e) {
        e.preventDefault();
        if ( e.which === 1 ) {
            let active_account = globalCh.request('active_account');
            this.changeAccount(active_account);
            return false;
        }
    },
    handle_selected_child: function(account, e) {
        var primary_account = globalCh.request('primary_account');
        if ( !account || (account.get('collaborator_mfa_required') === true && primary_account.get('mfa_enabled') === false )){
            return;
        }
        this.set_selected_child(account.id);
        this.trigger('select', account);
        if ( e.which === 1 ) return false;
    },
});

export default AccountChangeView;
